import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/common/Layout';
import Home from './pages/Home';
import Podcast from './pages/Podcast';
import Summary from './pages/Summary';
import SummaryNew from './pages/SummaryNew';
import SummaryAI from './pages/SummaryAI';
import Interview from './pages/Interview';
import LessonDetail from './pages/LessonDetail';
import TTSTest from './pages/TTSTest';
import TTSCompare from './pages/TTSCompare';
import Mindmap from './pages/Mindmap';
import QuizGenerate from './pages/QuizGenerate';

// 교사용 페이지
import TeacherLayout from './components/TeacherLayout';
import TeacherDashboard from './pages/teacher/TeacherDashboard';
import TTSManager from './pages/teacher/TTSManager';
import ContentManager from './pages/teacher/ContentManager';
import InterviewManager from './pages/teacher/InterviewManager';

import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        {/* 교사용 라우팅 (독립적 레이아웃) */}
        <Route path="/teacher" element={<TeacherLayout />}>
          <Route index element={<TeacherDashboard />} />
          <Route path="tts" element={<TTSManager />} />
          <Route path="content" element={<ContentManager />} />
          <Route path="interview" element={<InterviewManager />} />
          <Route path="analytics" element={<div className="p-8 text-center">📊 학습 분석 페이지 (개발 예정)</div>} />
        </Route>

        {/* 학생용 라우팅 (기존 Layout 사용) */}
        <Route path="/*" element={
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/summary" element={<SummaryAI />} />
              <Route path="/summary-edit" element={<SummaryNew />} />
              <Route path="/summary-old" element={<Summary />} />
              <Route path="/summary/lesson/:moduleId/:lessonId" element={<LessonDetail />} />
              <Route path="/podcast" element={<Podcast />} />
              <Route path="/mindmap" element={<Mindmap />} />
              <Route path="/quiz" element={<div className="p-8 text-center">퀴즈 페이지 (개발 예정)</div>} />
              <Route path="/quiz-generate" element={<QuizGenerate />} />
              <Route path="/parsons" element={<div className="p-8 text-center">파슨스 문제 페이지 (개발 예정)</div>} />
              <Route path="/interview" element={<Interview />} />
              <Route path="/tts-test" element={<TTSTest />} />
              <Route path="/tts-compare" element={<TTSCompare />} />
            </Routes>
          </Layout>
        } />
      </Routes>
    </Router>
  );
}

export default App;
